import { observer } from 'mobx-react-lite'
import { TouchableOpacity } from 'react-native'

export const IconButton = observer(({ onPress, children, ...rest }: React.ComponentProps<typeof TouchableOpacity>) => {
  return (
    <TouchableOpacity onPress={onPress} {...rest}>
      {children}
    </TouchableOpacity>
  )
})
